import { render, staticRenderFns } from "./module-item.vue?vue&type=template&id=77e59bea&scoped=true"
import script from "./module-item.vue?vue&type=script&lang=ts"
export * from "./module-item.vue?vue&type=script&lang=ts"
import style0 from "./module-item.vue?vue&type=style&index=0&id=77e59bea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e59bea",
  null
  
)

export default component.exports